const SPECIALIST_GUIDES_MENU_PATH = '/specialist-guides';
const ADMIN_SPECIALIST_GUIDES_MENU_PATH = '/admin-specialist-guides';
const DEFAULT_GUIDE_ROLES = 'pre-manager|manager|validator|editor|coordinator';

const ROLE_KEY_TO_NAME = {
  'pre-manager': 'Specialist-Pre-Manager',
  'pre-gestor': 'Specialist-Pre-Manager',
  manager: 'Specialist-Manager',
  gestor: 'Specialist-Manager',
  validator: 'Specialist-Validator',
  validador: 'Specialist-Validator',
  editor: 'Specialist-Editor',
  coordinator: 'Specialist-Coordinator',
  coordinador: 'Specialist-Coordinator',
  leader: 'Specialist-Feeder',
  lider: 'Specialist-Feeder',
  feeder: 'Specialist-Feeder'
};

const isTruthy = (value) => String(value ?? '').trim().toLowerCase() === 'true';

export const parseGuideRoleKeys = (raw = '', fallback = DEFAULT_GUIDE_ROLES) =>
  String(raw || fallback || '')
    .split('|')
    .map((item) => String(item || '').trim().toLowerCase())
    .filter(Boolean);

export const isSpecialistGuidesEnabled = (configurationState = {}) =>
  isTruthy(configurationState.specialistGuidesEnabled ?? 'true');

const collectUserRoleNames = (userRoleState = {}) => {
  const roles = userRoleState?.roleLogin?.roles || [];
  return roles
    .map((row) => row?.CatalogRole_To_UserRole?.name || row?.name || '')
    .filter(Boolean);
};

export const userMaySeeSpecialistGuidesMenu = (configurationState = {}, userRoleState = {}) => {
  if (!isSpecialistGuidesEnabled(configurationState)) {
    return false;
  }
  const roleKeys = parseGuideRoleKeys(configurationState.specialistGuidesRoles, DEFAULT_GUIDE_ROLES);
  const allowedNames = new Set(roleKeys.map((key) => ROLE_KEY_TO_NAME[key]).filter(Boolean));
  return collectUserRoleNames(userRoleState).some((name) => allowedNames.has(name));
};

export const filterMenusBySpecialistGuidesFlag = (menus = [], configurationState = {}, userRoleState = {}) => {
  const enabled = isSpecialistGuidesEnabled(configurationState);
  const specialistVisible = userMaySeeSpecialistGuidesMenu(configurationState, userRoleState);

  const filterTree = (items) => (items || [])
    .filter((item) => {
      if (item.path === ADMIN_SPECIALIST_GUIDES_MENU_PATH) {
        return enabled;
      }
      if (item.path === SPECIALIST_GUIDES_MENU_PATH) {
        return specialistVisible;
      }
      return true;
    })
    .map((item) => ({
      ...item,
      submenu: filterTree(item.submenu)
    }));

  return filterTree(menus);
};

export {
  SPECIALIST_GUIDES_MENU_PATH,
  ADMIN_SPECIALIST_GUIDES_MENU_PATH,
  DEFAULT_GUIDE_ROLES,
  ROLE_KEY_TO_NAME
};
